/**
 * The query string after a view's hash route ('#/oppgaver?due=overdue' → due=overdue): how a link from the dashboard
 * opens a list already filtered to what it counted. MKK adoption Batch 1. The router itself ignores it (App.tsx splits
 * the route at '?').
 */
export function hashQuery(): URLSearchParams {
  const h = typeof location !== 'undefined' ? location.hash : '';
  const i = h.indexOf('?');
  return new URLSearchParams(i >= 0 ? h.slice(i + 1) : '');
}
